// extracted by mini-css-extract-plugin
module.exports = {"header":"_d2833071"};